const init = () => {
  if (typeof BroadcastChannel === 'undefined') {
    return undefined;
  }

  class RoutingBroadcastChannel extends BroadcastChannel {
    constructor(name) {
      super(name);

      this.onmessage = (event) => {
        const { data } = event;
        const { action, payload } = data;
        const eventDispatcher = new CustomEvent(action, { detail: { ...payload } });
        this.dispatchEvent(eventDispatcher);
      };
    }

    openShipperOrder(id) {
      this.postMessage({ action: 'openShipperOrder', payload: { id } });
    }
  }

  return new RoutingBroadcastChannel();
};

const RoutingChannel = init();

export { RoutingChannel };
